import Cookies from '@/services/cookies'
import apiAuth from '@/api/auth'

const state = () => ({
})

const getters = {
}

const mutations = {
}

const actions = {
  getFrontSmsToken: (ctx, isForced = false) => new Promise((resolve, reject) => {
    if (!isForced && Cookies.get('_efst')) {
      return resolve()
    }

    const data = {
      ga: Cookies.get('_ga'),
    }

    apiAuth.getFrontSmsToken(data).then(response => {
      const efst = response?.data?.efst
      if (efst) {
        const threeMinutes = new Date(Date.now() + 3 * 60 * 1000)
        Cookies.set('_efst', efst, { expires: threeMinutes })
      }
      resolve()
    }).catch(error => {
      reject(error)
    })
  }),
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
